import { mapGetters } from 'vuex'
import { mapFields } from "vuex-map-fields"

export default {
  computed: {
    ...mapGetters({
      profile: 'main/profile'
    }),
    ...mapFields('plans', ['paymentInfo'])
  },
  methods: {
    renewPlan() {
      this.paymentInfo.plan = this.profile.subscription.plan

      this.$store.dispatch('plans/setCase', 'renew')

      this.paymentInfo.profilesCount = this.profile.subscription.browserProfiles.limit
      this.paymentInfo.additionalUsers = this.profile.subscription.users.limit
      this.paymentInfo.additionalProfiles = this.profile.subscription.browserProfiles.additionalProfiles

      this.$store.dispatch('plans/openDialog', 'prolongPlan')

      this.$amplitude.getInstance().logEvent('Click to Renew', {
        plan: this.profile.subscription.plan
      })
    }
  }
}
